import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=0cd5e831&scoped=true&"
import script from "../../models/menu-management/menu-list.ts?vue&type=script&lang=ts&"
export * from "../../models/menu-management/menu-list.ts?vue&type=script&lang=ts&"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=0cd5e831&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd5e831",
  null
  
)

export default component.exports